<ng-container *ifScreenSize="screenType.Desktop">
  <div class="banner" role="banner"></div>
</ng-container>

<ng-container *ifScreenSize="screenType.Mobile">
  <div class="container px-0">
    <fgb-barcode [isWalletPage]="false" [showBarcode]="true"></fgb-barcode>
  </div>
</ng-container>

<div *ngIf="partnerLimit$ | async as partnerLimit" class="container">
  <div class="mb-4 mt-2 mt-lg-0">
    <div class="m-0">
      <h5 class="mt-4 mb-2 title-partner">{{ 'partner.title' | translate }}</h5>
      <p class="m-0 font-size-14 partner-description" [innerHTML]="'partner.page.info.text' | translate | markdownTranslate"></p>

      <div class="m-0 flex-nowrap pe-0 ps-0">
        <div class="d-flex align-items-center flex-lg-row mb-4 mt-4">
          <button
            class="partner-button border-0 text-center text-white bg-primary pt-0 d-flex align-items-center justify-content-center me-lg-4 mb-3 mb-lg-0"
            (click)="openAddForm()"
            aria-label="Add new partner"
            [ngClass]="{
              active: !showAcceptForm,
              'not-active': showAcceptForm,
              'greyed-out': currentPartnerCount >= partnerLimit
            }"
          >
            <span class="material-icons me-2 text-secondary"> person_add_alt_1 </span>
            <label class="cursor-pointer mb-0 text-secondary">{{ 'add.new.partner.button' | translate }}</label>
          </button>
        </div>
      </div>
    </div>
    <ng-container *ngIf="showAddForm || showAcceptForm">
      <hr class="m-2" />
      <div class="card-body">
        <fgb-partner-add-form (close)="openAddForm()" *ngIf="showAddForm"></fgb-partner-add-form>
        <fgb-partner-accept-form (close)="openAcceptForm()" *ngIf="showAcceptForm"></fgb-partner-accept-form>
      </div>
    </ng-container>
  </div>
  <ng-container *ngIf="currentPartnerCount > 0; else partnerPlaceholder">
    <fgb-partner-list></fgb-partner-list>
  </ng-container>
  <ng-template #partnerPlaceholder>
    <h5 class="mt-4 mb-2 title-partner">{{ 'partner.list.partner.title' | translate }}</h5>
    <div class="card border card-primary my-2 bg-white font-size-14">
      <div class="card-body pt-3">
        <div class="row text-start details-header mx-0">
          <div class="col-10 col-lg-3 d-lg-none d-block">
            <label class="fw-bold">{{ 'partner.details' | translate }}</label>
          </div>
          <div class="col-4 d-lg-block d-none ps-0">
            <label class="fw-bold">{{ 'partner.fullname' | translate }}</label>
          </div>
          <div class="col-5 d-lg-block d-none">
            <label class="fw-bold">{{ 'partner.email' | translate }}</label>
          </div>
          <div class="col-2 d-lg-block d-none ps-0">
            <label class="fw-bold">{{ 'partner.status' | translate }}</label>
          </div>
          <div class="col-1 d-lg-block d-none">
            <label class="fw-bold">{{ 'partner.action' | translate }}</label>
          </div>
          <div class="col-3 d-lg-block d-none"></div>
        </div>
        <div class="text-center font-size-12 mt-3">
          {{ 'no.partner.placeholder.description' | translate }}
        </div>
      </div>
    </div>
  </ng-template>
</div>
